import React from "react";
import ReactDOM from "react-dom";
import MarkdownIt from "markdown-it";

const md = new MarkdownIt();

class Accordion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 0,
    };
  }

  componentDidMount() {
    const el = ReactDOM.findDOMNode(this);
    const height = el.querySelector(".panel__inner").scrollHeight;
    this.setState({
      height,
    });
  }

  render() {
    const {
      roleDetails,
      activeTab,
      index,
      activateTab,
      onRoleChanged,
      selectedRoleId,
    } = this.props;
    const {
      id: roleId,
      name: jobTitle,
      description: jobDescription,
    } = roleDetails;

    const { height } = this.state;
    const isActive = activeTab === index;

    return (
      <div className="panel" role="tabpanel" aria-expanded={isActive}>
        <div
          className="flexrow"
          style={{ justifyContent: "space-between", alignItems: "center" }}
        >
          <div>
            <input
              type="checkbox"
              name="role"
              value={roleId}
              checked={roleId === selectedRoleId}
              readOnly={true}
            />
            <label
              className="panel_label"
              onClick={() => onRoleChanged(roleId)}
            >
              {jobTitle}
            </label>
          </div>
          {!!jobDescription ? (
            <a
              className="panel__action"
              role="tab"
              style={{ textDecoration: "underline", cursor: "pointer" }}
              onClick={activateTab}
            >{`${isActive ? "Hide" : "Show"} Job Description`}</a>
          ) : null}
        </div>

        <div
          className="panel__inner"
          style={{ height: `${isActive ? height : 0}px` }}
          aria-hidden={!isActive}
        >
          {!!jobDescription ? (
            <div
              className="panel__content"
              dangerouslySetInnerHTML={{ __html: md.render(jobDescription) }}
            ></div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default Accordion;



// WEBPACK FOOTER //
// ./src/components/Modals/Company/Accordion.js